export function time12hour(value) {
    if (!value) return '';
    const [hour, minute] = value.split(':');
    const date = new Date();
    date.setHours(hour, minute);
    return date.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });
}


export function timeZone(value) {
  if (!value) return '';

  // Match time and optional timezone offset
  const match = value.match(/^(\d{2}):(\d{2})(?::\d{2})?([+-]\d{2}:\d{2})?$/);
  if (!match) return '';

  const offset = match[3]; // match[3] contains the offset part
  return offset || '';
}